module.exports = __webpack_public_path__ + "img/homepage_about_us_mobile.d5af1b00.webp";